//dependencies
import React from "react";
import Markdown, { Components } from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";

//utils
import { defaultMarkdownComponentOverrides } from "./utils";

//css
import css from "./MarkdownReader.module.scss";

// unit test mocks for this should be removed fter moving to Vitest
// per https://github.com/orgs/remarkjs/discussions/1247 the maintainer says they do not support Jest modules

type MarkdownReaderProps = {
	/**
	 * The markdown text to render
	 */
	markdownText: string;
	/**
	 * Whether or not to allow HTML in the markdown
	 */
	allowHTML?: boolean;
	/**
	 * Override components for markdown rendering
	 */
	overrideComponents?: Components;

	/**
	 * className to apply to the markdown reader
	 */
	className?: string;
};

const MarkdownReader = ({
	markdownText = "",
	allowHTML = false,
	overrideComponents,
	className = "",
}: MarkdownReaderProps) => {
	// Preserve ALL newlines and leading spaces with &nbsp;, while respecting multi-line breaks
	const formattedText = markdownText
		.replace(/^( *)/gm, (match) => match.replace(/ /g, "&nbsp;")) // Transform leading spaces
		.replace(/\n/g, "\n&nbsp;"); // Preserve newlines explicitly

	// allow HTML in markdown
	const rehypePlugins = allowHTML ? [rehypeRaw] : [];

	// Override the default components with the provided overrides
	const componentOverrides: Components = { ...defaultMarkdownComponentOverrides, ...overrideComponents };

	return (
		<Markdown
			remarkPlugins={[remarkGfm, remarkBreaks]}
			rehypePlugins={rehypePlugins}
			components={componentOverrides}
			className={`${css.markdownReader} ${className}`}
		>
			{formattedText}
		</Markdown>
	);
};

export default MarkdownReader;
